<autocomplete-option>
  <div class="main">
    <span [innerHTML]="airport | airportName | highlight: highlight"></span>
  </div>
</autocomplete-option>
